import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import products from '../data/products';

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <div style={{ background: '#080808', minHeight: '100vh', color: '#f0f0f0', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'DM Sans, sans-serif' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>😕</div>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', letterSpacing: '2px', marginBottom: '8px' }}>DEAL NOT FOUND</div>
        <button onClick={() => navigate('/')} style={{ background: '#ff3c00', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 28px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '16px' }}>
          Back to Deals
        </button>
      </div>
    );
  }

  const savings = product.originalPrice - product.salePrice;

  // Related products: same brand, exclude current
  const relatedProducts = products.filter(p => p.brand === product.brand && p.id !== product.id);

  return (
    <div style={{ background: '#080808', minHeight: '100vh', color: '#f0f0f0', fontFamily: 'DM Sans, sans-serif', paddingBottom: '120px' }}>

      {/* NAVBAR */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        padding: '16px 24px', display: 'flex', alignItems: 'center',
        gap: '16px', background: 'rgba(8,8,8,0.9)',
        backdropFilter: 'blur(12px)', borderBottom: '1px solid #242424'
      }}>
        <button onClick={() => navigate(-1)} style={{
          background: '#1c1c1c', border: '1px solid #242424', borderRadius: '8px',
          padding: '8px 14px', color: '#f0f0f0', fontSize: '16px', cursor: 'pointer'
        }}>
          ←
        </button>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '3px' }}>
          FIT<span style={{ color: '#ff3c00' }}>OFF</span>
        </div>
      </nav>

      {/* PRODUCT IMAGE */}
      <div style={{
        marginTop: '62px',
        background: '#131313',
        height: '280px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        fontSize: '120px'
      }}>
        {product.image}
        <div style={{
          position: 'absolute', top: '16px', left: '16px',
          background: '#ff3c00', color: 'white',
          fontWeight: 'bold', fontSize: '18px',
          padding: '4px 12px', borderRadius: '8px'
        }}>
          -{product.discount}%
        </div>
      </div>

      {/* PRODUCT INFO */}
      <div style={{ padding: '24px' }}>

        {/* Brand */}
        <div style={{ fontSize: '12px', color: '#ff3c00', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600', marginBottom: '8px' }}>
          {product.brand}
        </div>

        {/* Name */}
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '36px', letterSpacing: '2px', lineHeight: '1', marginBottom: '20px' }}>
          {product.name}
        </div>

        {/* Price block */}
        <div style={{
          background: '#131313', border: '1px solid #242424',
          borderRadius: '16px', padding: '20px', marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '12px', marginBottom: '12px' }}>
            <span style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '48px', color: '#ffb800', lineHeight: 1 }}>
              ${product.salePrice}
            </span>
            <span style={{ fontSize: '20px', color: '#606060', textDecoration: 'line-through', paddingBottom: '6px' }}>
              ${product.originalPrice}
            </span>
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <div style={{
              flex: 1, background: 'rgba(255,60,0,0.1)', border: '1px solid rgba(255,60,0,0.2)',
              borderRadius: '10px', padding: '12px', textAlign: 'center'
            }}>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#ff3c00' }}>{product.discount}%</div>
              <div style={{ fontSize: '11px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px' }}>Off</div>
            </div>
            <div style={{
              flex: 1, background: 'rgba(255,184,0,0.1)', border: '1px solid rgba(255,184,0,0.2)',
              borderRadius: '10px', padding: '12px', textAlign: 'center'
            }}>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#ffb800' }}>${savings}</div>
              <div style={{ fontSize: '11px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px' }}>Saved</div>
            </div>
            <div style={{
              flex: 1, background: 'rgba(255,184,0,0.05)', border: '1px solid #242424',
              borderRadius: '10px', padding: '12px', textAlign: 'center'
            }}>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#f0f0f0' }}>{product.category}</div>
              <div style={{ fontSize: '11px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px' }}>Category</div>
            </div>
          </div>
        </div>

        {/* Urgency nudge */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          background: 'rgba(255,60,0,0.08)', border: '1px solid rgba(255,60,0,0.2)',
          borderRadius: '10px', padding: '12px 16px', marginBottom: '20px'
        }}>
          <div style={{ width: '8px', height: '8px', background: '#ff3c00', borderRadius: '50%' }}></div>
          <span style={{ fontSize: '13px', color: '#ff3c00' }}>Clearance pricing — limited stock, deal may end anytime</span>
        </div>

        {/* Related products */}
        {relatedProducts.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', letterSpacing: '2px', marginBottom: '12px' }}>
              MORE FROM {product.brand.toUpperCase()}
            </div>
            <div style={{ display: 'flex', gap: '10px', overflowX: 'auto' }}>
              {relatedProducts.map(p => (
                <div key={p.id} onClick={() => navigate(`/product/${p.id}`)} style={{
                  flexShrink: 0, background: '#131313', border: '1px solid #242424',
                  borderRadius: '12px', padding: '12px', cursor: 'pointer', width: '130px'
                }}>
                  <div style={{ fontSize: '36px', textAlign: 'center', marginBottom: '8px' }}>{p.image}</div>
                  <div style={{ fontSize: '11px', color: '#606060', marginBottom: '2px' }}>{p.name}</div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffb800' }}>${p.salePrice}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* STICKY CTA */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        padding: '16px 24px 32px',
        background: 'rgba(8,8,8,0.97)', backdropFilter: 'blur(12px)',
        borderTop: '1px solid #242424'
      }}>
        <button
          onClick={() => window.open(product.link, '_blank')}
          style={{
            width: '100%', background: '#ff3c00', color: 'white',
            border: 'none', borderRadius: '12px', padding: '18px',
            fontSize: '16px', fontWeight: '700', cursor: 'pointer',
            fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
          }}
        >
          GET THIS DEAL — ${product.salePrice} →
        </button>
      </div>

    </div>
  );
}

export default ProductDetail;